import Axios from 'axios'
import Config from '../config/app.js'
import {
    Notification,
    Message,
    Loading
} from 'element-ui';
import {
    getToken,
    removeToken,
    removeUserInfo,
    getShopMemberId,
    getMember
} from '../utils/dataStorage.js'
let headers = {
    'Accept': 'application/json',
}
let headers2 = {
    "Content-Type": "multipart/form-data;",
}
const service = Axios.create({
    baseURL: Config.apiUrl + Config.apiPrefix,
    headers:{
        'Accept': 'application/json',
    },
    timeout: Config.timeout,
    closeLoading: true,
    login: true
})
service.defaults.retry = Config.requestRetry;
service.defaults.retryDelay = Config.requestRetryDelay;

service.interceptors.request.use(
    config => {
        if (!config.closeLoading) {
            window.loadingInstance = Loading.service();
        }
        // let noParameters = config.url.indexOf('?') == -1;
        // if(config.url.indexOf('touch_service/xhs/upload') > -1){
        //     config.headers['Content-Type'] = "multipart/form-data;"
        // }
        var token = getToken();
        //config.url = noParameters ? config.url + '?access_token=' + getToken() : config.url + '&access_token=' + getToken();
        if (token && config.login) {
            config.headers[Config.tokenKey] = (token);
        }
        var shopMemberId = getShopMemberId();
        if (shopMemberId) {
            config.headers[Config.shopMemberId] = escape(shopMemberId);
        }
        var shopIds = getMember() ? getMember().shopDataList.map(item => item.shopId).toString() : ''
        if (shopIds && config.url != '/api/payment_order/pay') {
            config.headers[Config.shopIds] = shopIds;
        }
        return config
    },
    error => {
        Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        if (!response.config.closeLoading) {
            setTimeout(_ => {
                window.loadingInstance.close();
            }, 400);
        }
        const res = response
        if (res.status !== 200 && res.status !== 201) {
            Notification({
                title: '温馨提示',
                message: "服务器可能遇到问题，请稍后重试",
                type: 'warning'
            });
        } else {
            if ((response.config).hasOwnProperty('closeInterceptors') && response.config.closeInterceptors) {
                return res.data
            }

            if (res.data.code != 0) {
                if (res.data.code == 1) {
                    return res.data.data
                } else if (res.data.code == 2) {
                    Message({
                        message: res.data.msg,
                        type: 'warning'
                    });
                } else if (res.data.code == 8) {
                    // 登录状态失效
                    setTimeout(_ => {
                        window.location.href = '#/login';
                    }, 1000)
                } else if (res.data.code == 6) {
                    // 接口权限不足
                    Message({
                        message: res.data.msg,
                        type: 'warning'
                    });
                }if (res.data.code >= 40001) {
                    return Promise.reject(res.data);
                } else {
                    Message({
                        message: res.data.msg,
                        type: 'error'
                    });
                }
                return Promise.reject('error');
            }
            return res.data.data
        }
    },
    error => {
        console.error(error)
        setTimeout(_ => {
            window.loadingInstance.close();
        }, 300)
        Notification({
            title: "提示",
            message: "服务器可能遇到问题，请稍后重试",
            type: 'warning'
        });
        return Promise.reject(error)
    }
)

export default service